import React from "react";

function Iconfont({ type, style, onClick, className, ...rest }) {
  return (
    <svg
      style={style}
      className={className ? `icon ${className}` : "icon"}
      aria-hidden="true"
      onClick={onClick}
      {...rest}
    >
      <use xlinkHref={`#${type}`}></use>
    </svg>
  );
}

export default Iconfont;
